module.exports = __webpack_public_path__ + "img/framenew_box17.f95ffb8f.jpg";